import React from "react";

export const TrashFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 5.5v-1a.5.5 0 00-.5-.5H15V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zM7.72 18h8.56L17 8h2l-.85 12.14a2 2 0 01-2 1.86H7.87a2 2 0 01-2-1.86L5 8h2l.72 10z"
      clipRule="evenodd"
    ></path>
  </svg>
);
